import { supabase } from "@/integrations/supabase/client";

/**
 * Ensures an artist profile exists and creates one if it doesn't
 */
export async function ensureArtistProfileExists(artistId: string) {
  try {
    // Check if artist profile exists
    const { data: artistProfileExists, error: checkError } = await supabase
      .from("artist_profiles")
      .select("id")
      .eq("id", artistId)
      .maybeSingle();

    if (checkError) {
      console.error("Error checking artist profile:", checkError);
      return false;
    }

    if (artistProfileExists) {
      return true; // Profile already exists
    }

    // Artist profile doesn't exist, create one
    console.log("Creating missing artist profile for:", artistId);

    // Get user data from public_profiles
    const { data: userData, error: userError } = await supabase
      .from("public_profiles")
      .select("display_name")
      .eq("id", artistId)
      .single();

    if (userError) {
      console.error("Error fetching user data:", userError);
      return false;
    }

    // Create artist profile
    const { error: createError } = await supabase
      .from("artist_profiles")
      .insert({
        id: artistId,
        name: userData?.display_name || "Artist",
        stream_count: 0,
        track_count: 0,
      });

    if (createError) {
      console.error("Error creating artist profile:", createError);
      return false;
    }

    return true;
  } catch (error) {
    console.error("Error ensuring artist profile exists:", error);
    return false;
  }
}
